import { t } from "i18next";
import style from "./Slide.module.scss";
import SlideWrapper from "./SlideWrapper";

interface InformacijeOSistemuProps {
  goBackHandler: () => void;
}

const InformacijeOSistemu = ({ goBackHandler }: InformacijeOSistemuProps) => {
  return (
    <SlideWrapper
      title={t("LOGIN.INFORMACIJE_O_SISTEMU")}
      goBackHandler={goBackHandler}
    >
      <p className={style.cardText}>
        {t("LOGIN.INFORMACIJE_O_SISTEMU_PARAGRAPH_1")}
      </p>

      <p className={style.cardText}>
        {t("LOGIN.INFORMACIJE_O_SISTEMU_PARAGRAPH_2")}
      </p>

      <p className={style.cardText}>
        {t("LOGIN.INFORMACIJE_O_SISTEMU_PARAGRAPH_3")}
      </p>

      <p className={style.cardText}>
        {t("LOGIN.INFORMACIJE_O_SISTEMU_PARAGRAPH_4")}
      </p>

      <p className={style.cardText}>
        {t("LOGIN.INFORMACIJE_O_SISTEMU_PARAGRAPH_5")}
      </p>

      <p className={style.cardText}>
        {t("LOGIN.INFORMACIJE_O_SISTEMU_PARAGRAPH_6")}
      </p>
      <ol className={style.cardText}>
        <li>{t("LOGIN.MINISTARTSVO_FINANSIJA")};</li>
        <li>{t("LOGIN.PORESKA_UPRAVA")};</li>
        <li>{t("LOGIN.UPRAVA_CARINA")};</li>
        <li>{t("LOGIN.UPRAVA_ZA_DUVAN")};</li>
        <li>{t("LOGIN.NARODNA_BANKA_SRBIJE")};</li>
        <li>{t("LOGIN.OBVEZNICI_AKCIZE")};</li>
        <li>{t("LOGIN.TRGOVCI_NA_VELIKO_I_NA_MALO")}.</li>
      </ol>
    </SlideWrapper>
  );
};

export default InformacijeOSistemu;
